import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import expenseTimeLineApi from '../../../../middleware/api/ExpenseManagement/ExpensesList/ExpensesTimeLine/expensesTimeLineApi'
import { AppDispatch, RootState } from '../../../../stateStore'
import {
  ExpenseTimeLineTypes,
  expenseTimelineSliceState,
} from '../../../../types/ExpenseManagement/ExpenseList/ExpensesTimeLine/expensesTimeLineTypes'
import { LoadingState, ValidationError } from '../../../../types/commonTypes'
import { ApiLoadingState } from '../../../../middleware/api/apiList'

const getExpenseFormTimeline = createAsyncThunk<
  ExpenseTimeLineTypes[],
  number,
  {
    dispatch: AppDispatch
    state: RootState
    rejectValue: ValidationError
  }
>('getExpenseFormTimeline', async (formId: number, thunkApi) => {
  try {
    return await expenseTimeLineApi.getExpenseFormTimeline(formId)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status as ValidationError)
  }
})

const initialExpenseListTimeLineState: expenseTimelineSliceState = {
  expenseTimeLineTypes: [],
  isLoading: ApiLoadingState.idle,
}

const expensesTimeLineSlice = createSlice({
  name: 'expensesTimeLine',
  initialState: initialExpenseListTimeLineState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExpenseFormTimeline.fulfilled, (state, action) => {
      state.isLoading = ApiLoadingState.succeeded
      state.expenseTimeLineTypes = action.payload
    })
    builder.addCase(getExpenseFormTimeline.pending, (state) => {
      state.isLoading = ApiLoadingState.loading
    })
  },
})

const expensesTimeLineThunk = {
  getExpenseFormTimeline,
}

const isLoading = (state: RootState): LoadingState =>
  state.expensesTimeLine.isLoading

const expenseTimeLine = (state: RootState): ExpenseTimeLineTypes[] =>
  state.expensesTimeLine.expenseTimeLineTypes

const expensesTimeLineSelectors = {
  isLoading,
  expenseTimeLine,
}

export const expensesTimeLineService = {
  ...expensesTimeLineThunk,
  actions: expensesTimeLineSlice.actions,
  selectors: expensesTimeLineSelectors,
}

export default expensesTimeLineSlice.reducer
